import { render, staticRenderFns } from "./InfoBtn.vue?vue&type=template&id=709bcbf3&scoped=true"
import script from "./InfoBtn.vue?vue&type=script&lang=js"
export * from "./InfoBtn.vue?vue&type=script&lang=js"
import style0 from "./InfoBtn.vue?vue&type=style&index=0&id=709bcbf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709bcbf3",
  null
  
)

export default component.exports